import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
    {
        step: "01",
        title: "Coleta de Evidências",
        text: "Cruzamos dados internos do seu negócio com evidências públicas (como a percepção real dos seus clientes no Google Maps).",
    },
    {
        step: "02",
        title: "O Esboço Investigativo",
        text: "Entregamos um raio-x inicial gratuito, mostrando ONDE e QUANTO você está perdendo, sem revelar a solução.",
    },
    {
        step: "03",
        title: "A Investigação Completa",
        text: "Aprofundamos a análise, calculamos a Oportunidade Capturável e entregamos um plano de ação priorizado e cirúrgico.",
    },
];

export default function Process() {
    return (
        <section className="relative px-6 py-28 lg:px-10 lg:py-36" data-testid="process-section">
            <div className="mx-auto max-w-7xl">
                <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
                    <div className="max-w-2xl">
                        <Reveal>
                            <Eyebrow>Exhibit C — O Processo</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h2 className="mt-7 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
                                Do Diagnóstico à <em className="italic text-gold">Ação</em>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.14}>
                        <p className="max-w-xs font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-[#666666]">
                            Três etapas. Nenhuma promessa. Apenas o que as evidências
                            permitirem afirmar.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid gap-px border border-line bg-line md:grid-cols-3">
                    {STEPS.map((s, i) => (
                        <Reveal
                            key={s.step}
                            delay={i * 0.08}
                            className="group relative bg-[#0a0a0a] p-10 transition-colors duration-300 hover:bg-[#141414]"
                        >
                            <div data-testid={`process-step-${i + 1}`}>
                                <span className="font-display text-6xl leading-none text-stroke-gold transition-opacity duration-300 group-hover:opacity-100">
                                    {s.step}
                                </span>
                                <h3 className="mt-8 font-serif text-xl text-white">{s.title}</h3>
                                <p className="mt-4 text-[15px] leading-relaxed text-[#9a9a9a]">
                                    {s.text}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
